export const isProduction = process.env.NEXT_PUBLIC_APP_ENV === "production";
export const isStaging = process.env.NEXT_PUBLIC_APP_ENV === "staging";
